import type { BoxProps } from '@hover/blueprint';
import { Box, HStack } from '@hover/blueprint';
import { Skeleton } from '@hover/blueprint/chakra';
import type { ReactNode } from 'react';
import React from 'react';

interface ProjectItemContainerProps extends BoxProps {
  children: ReactNode;
  isLoading?: boolean;
}

export const ProjectItemContainer = ({
  children,
  isLoading,
  ...props
}: ProjectItemContainerProps) => (
  <Box
    cursor={isLoading ? undefined : 'pointer'}
    marginBottom={200}
    marginTop={100}
    paddingX={{ base: 200, tablet: 400 }}
    width="100%"
    {...props}
  >
    <HStack justifyContent="space-between" marginY={100} width="100%">
      {children}
    </HStack>
  </Box>
);

export const ProjectMenuLoadingItem = ({ ...props }: BoxProps) => (
  <ProjectItemContainer {...props}>
    <Skeleton borderRadius={300} height="80px" width="80px" />
    <Skeleton flexGrow={1} height={75} />
  </ProjectItemContainer>
);
